type ImageType = string;
type ImageStore = Record<string, ImageType>;
export interface UseImageStoreReturn {
  setImage: (key: string, value: ImageType) => void;
  setImages: (store: ImageStore) => void;
  getImage: (key: string) => ImageType | null;
  removeImage: (key: string) => void;
  storeKeys: string[];
  storeValues: ImageType[];
  entries: [string, ImageType][];
}

export function createImageStore(): UseImageStoreReturn {
  let state: ImageStore = {};

  const setImage = (key: string, image: ImageType) => {
    state = { ...state, [key]: image };
  };

  const setImages = (store: ImageStore) => {
    state = { ...state, ...store };
  };

  const removeImage = (key: string) => {
    delete state[key];
  };

  const getImage = (key: string) => {
    if (state[key] === undefined) {
      return null;
    }

    return state[key];
  };
  const keys = Object.keys(state);
  const values = Object.values(state);
  const entries = Object.entries(state);
  return {
    setImage,
    setImages,
    removeImage,
    getImage,
    storeKeys: keys,
    storeValues: values,
    entries
  };
}
